<template>
  <div class="message-item line-numbers">
    <div :class="isAssistant ? 'avatar' : 'user avatar'">
      <img v-if="isAssistant" src="@/assets/ai/ai.png" style="object-fit: contain;" />
      <img v-else src="@/assets/ai/user.png" />
    </div>
    <div class="content-container">
      <span class="time" v-if="time">{{ time }}</span>
      <div ref="markdownContainer" v-if="isAssistant" class="content assistant" :class="{ loading: state !== 3 && (!content || !content.length), error: state === 3 }">
        <span v-if="state !== 3 && (!content || !content.length)">
          <i class="el-icon-loading" style="margin-right: 5px;font-size: 14px" />小衍正在思考...
        </span>
        <span v-else v-html="markdownToHtml" />
      </div>
      <div v-else class="content user">
        {{ content }}
      </div>
    </div>
  </div>
</template>

<script>
import Prism from "prismjs";
import "prismjs/themes/prism.css"; // 引入 Prism.js 的 CSS 主题

export default {
  props: {
    role: String,
    content: String,
    time: String,
    state: Number,
  },
  data() {
    return {
      assistantContentLoading: false,
      errorContent: '<div style="color: red;">错误</div>',
    };
  },
  mounted() {
    this.highlightCodeBlocks();
  },
  updated() {
    this.highlightCodeBlocks();
    this.$el.querySelectorAll(".result-img").forEach((img) => {
      img.addEventListener("click", this.handleImgPreview);
    });
  },
  computed: {
    isAssistant() {
      return this.role === "assistant";
    },
    markdownToHtml() {
      return this.state === 3 ? this.errorContent : this.content
    },
    loading() {
      return this.state !== 3 && (!this.content || !this.content.length)
    }
  },
  methods: {
    highlightCodeBlocks() {
      if (!this.isAssistant) return;

      const markdownContainer = this.$refs.markdownContainer;
      if (!markdownContainer) return;

      const codeBlocks = markdownContainer.querySelectorAll("pre code");
      codeBlocks.forEach((codeBlock) => {
        Prism.highlightElement(codeBlock);
      });
    },
    handleImgPreview(e) {
      console.log("handleImgPreview", e.srcElement.currentSrc);
      this.$viewerApi({
        images: [e.srcElement.currentSrc],
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.message-item {
  display: flex;
  align-items: top;
  margin-bottom: 20px;
  z-index: 2;
  position: relative;

  .avatar {
    height: 40px;
    width: 40px;
    margin-right: 15px;
    margin-top: 3.5px;
    border-radius: 3px;
    flex-shrink: 0;
    background: #e5e5e5;
    padding: 5px;

    &.user {
      background: #c0c4cc;
      padding: 0;
    }

    img {
      height: 100%;
      width: 100%;
      border-radius: 3px;
    }
  }

  .content-container {
    .time {
      color: rgb(107 114 128);
      background-color: rgb(243 244 246);
      font-size: 10px;
      padding: 3px;
      border-radius: 3px;
    }

    .content {
      padding: 10px 15px;
      border-top-right-radius: 8px;
      border-bottom-right-radius: 8px;
      border-bottom-left-radius: 8px;
      margin-top: 10px;
      font-size: 14px;

      &.user {
        background: #d4e3fc;
      }

      &.assistant {
        background: rgb(249 250 251);
        border: 1px solid rgb(229 231 235);
        min-width: 600px;
      }

      &.loading, &.error {
        min-width: auto;
      }

      .result-img {
        cursor: pointer;
      }
    }
  }
}
</style>
